import { lazy, Suspense } from 'react';
import { Outlet, Navigate, useRoutes } from 'react-router-dom';
import MainLayout from '../layouts/main/main';
// import AuthGuard from '../auth/guard/auth-guard';

// POC BYPASS: Removed AuthGuard import and usage
// All routes are now accessible without authentication

// ----------------------------------------------------------------------

// Import actual pages that exist
export const HomePage = lazy(() => import('../pages/home/home'));
export const LoginPage = lazy(() => import('../pages/auth/login/login'));
export const PreviewPage = lazy(() => import('../pages/preview/preview'));
export const LeafFilterSheetPage = lazy(() => import('../pages/leaf-filter-sheet/leaf-filter-sheet'));
export const CameraCapturePageComponent = lazy(() => import('../pages/camera-capture/camera-capture'));
export const SingleLeadPage = lazy(() => import('../pages/single-lead/single-lead'));

// ----------------------------------------------------------------------

export default function Router() {
  const routes = useRoutes([
    {
      path: '/',
      element: (
        <MainLayout>
          <Suspense fallback={<div>Loading...</div>}>
            <Outlet />
          </Suspense>
        </MainLayout>
      ),
      children: [
        // POC BYPASS: Default route goes directly to home instead of login
        { element: <Navigate to="/home" replace />, index: true },
        { path: 'home', element: <HomePage /> },
        { path: 'leads/:_id', element: <SingleLeadPage /> },
        { path: 'gutter-sheet/:_id', element: <PreviewPage /> },
        { path: 'leaf-filter-sheet/:_id', element: <LeafFilterSheetPage /> },
        { path: 'scan/:_id/:leadRef', element: <CameraCapturePageComponent /> },
      ],
    },
    // POC BYPASS: Login route still exists but is not used in normal flow
    {
      path: '/auth/login',
      element: <LoginPage />,
    },
    {
      path: '*',
      element: <Navigate to="/home" replace />,
    },
  ]);

  return routes;
}

/* ORIGINAL ROUTER WITH AUTH - COMMENTED OUT FOR POC
export default function Router() {
  const routes = useRoutes([
    {
      path: '/',
      element: (
        <AuthGuard>
          <MainLayout>
            <Suspense fallback={<div>Loading...</div>}>
              <Outlet />
            </Suspense>
          </MainLayout>
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to="/home" replace />, index: true },
        { path: 'home', element: <HomePage /> },
        { path: 'leads/:_id', element: <SingleLeadPage /> },
        { path: 'gutter-sheet/:_id', element: <PreviewPage /> },
        { path: 'leaf-filter-sheet/:_id', element: <LeafFilterSheetPage /> },
        { path: 'scan/:_id/:leadRef', element: <CameraCapturePageComponent /> },
      ],
    },
    {
      path: '/auth/login',
      element: <LoginPage />,
    },
    {
      path: '*',
      element: <Navigate to="/home" replace />,
    },
  ]);

  return routes;
}
*/
